import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import EzTextInput from "../EzField/EzTextInput.es.js";
import stitches from "../theme.config.es.js";
const searchInput = stitches.css({
  backgroundRepeat: "no-repeat",
  backgroundPosition: "12px center, calc(100% - 10px) center",
  backgroundImage: "$search-input-background-image",
  "&&": {
    paddingLeft: "$search-input-padding-left"
  },
  WebkitAppearance: "none"
});
const EzSearchInput = forwardRef((props, ref) => /* @__PURE__ */ jsx(EzTextInput, { ref, ...props, className: searchInput(), type: "search" }));
EzSearchInput.displayName = "EzSearchInput";
export {
  EzSearchInput as default
};
//# sourceMappingURL=EzSearchInput.es.js.map
